import { FieldPattern } from '..';

import { FORM_FIELD_GROUP } from '../../../../constants/FieldTypeConstants';
import { getFieldFromFactory } from '../../../../factories/FieldFactory';
import {
  AllFormFieldModelsType,
  FormFieldsType
} from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class FormFieldGroup extends FormFieldWithInitialValue {
  readonly type: string = FORM_FIELD_GROUP;
  formFields: Array<AllFormFieldModelsType>;
  constructor(multipleSelectData: any) {
    super(multipleSelectData, '');
    this.formFields = this.getFormFieldsModels(multipleSelectData.form_fields);
  }
  getFormFieldsModels = (
    fieldsData: FormFieldsType[]
  ): Array<AllFormFieldModelsType> => {
    return fieldsData.map((eachField) => {
      return getFieldFromFactory(eachField, null);
    });
  };
  match<T>(p: FieldPattern<T>): T {
    return p.FormFieldGroup(this);
  }
}
export default FormFieldGroup;
